import React, { ChangeEvent } from "react";
import * as S from "./userInfoEditPageContent.style";
import { Button } from "../../atoms/Buttons";

type UserInfoEditPageContentType = {
  handleSubmit: any;
  register: any;
  handlePhoneNumberChange: (e: ChangeEvent<HTMLInputElement>) => void;
  errors: any;
  onBackHanlder: () => void;
  onSubmit: (data: any) => Promise<void>;
};

const UserInfoEditPageContent = ({
  handleSubmit,
  register,
  handlePhoneNumberChange,
  onBackHanlder,
  errors,
  onSubmit,
}: UserInfoEditPageContentType) => {
  return (
    <S.UserInfoEditContentLayout onSubmit={handleSubmit(onSubmit)}>
      <div className="contentBox">
        <S.UserPasswordEditContentLayout>
          <S.UserEditContentTitlBox>
            <S.UserEditContentTitle>비밀번호 변경</S.UserEditContentTitle>
            <p className="pointText">**변경할 경우에만 입력</p>
          </S.UserEditContentTitlBox>
          <S.InputBox>
            <input
              type="password"
              placeholder="현재 비밀번호"
              {...register("currentPassword")}
            />
            {errors ? (
              <p className="error-text">{errors["currentPassword"]?.message}</p>
            ) : (
              ""
            )}
          </S.InputBox>
          <S.InputBox>
            <input
              type="password"
              placeholder="비밀번호 변경"
              {...register("newPassword")}
            />
            {errors ? (
              <p className="error-text">{errors["newPassword"]?.message}</p>
            ) : (
              ""
            )}
          </S.InputBox>
          <S.InputBox>
            <input
              type="password"
              placeholder="비밀번호 변경 확인"
              {...register("newPasswordCheck")}
            />
            {errors ? (
              <p className="error-text">
                {errors["newPasswordCheck"]?.message}
              </p>
            ) : (
              ""
            )}
          </S.InputBox>
        </S.UserPasswordEditContentLayout>
        <S.UserDefaultInfoEditContentLayout>
          <S.UserEditContentTitlBox>
            <S.UserEditContentTitle> 기본정보 수정 </S.UserEditContentTitle>
          </S.UserEditContentTitlBox>
          <S.InputBox className="userInfoDefault">
            <input type="text" {...register("username")} />
            <S.InputLabelText> 이름 </S.InputLabelText>
            {errors ? (
              <p className="error-text">{errors["username"]?.message}</p>
            ) : (
              ""
            )}
          </S.InputBox>
          <S.InputBox className="userInfoDefault">
            <input
              type="text"
              {...register("phoneNumber")}
              maxLength={13}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                handlePhoneNumberChange(e);
              }}
            />
            <S.InputLabelText> 휴대폰번호 </S.InputLabelText>
            {errors ? (
              <p className="error-text">{errors["phoneNumber"]?.message}</p>
            ) : (
              ""
            )}
          </S.InputBox>
          <S.InputBox className="userInfoDefault">
            <input type="text" {...register("email")} />
            <S.InputLabelText> 이메일 </S.InputLabelText>
            {errors ? (
              <p className="error-text">{errors["email"]?.message}</p>
            ) : (
              ""
            )}
          </S.InputBox>
        </S.UserDefaultInfoEditContentLayout>
      </div>
      <S.ButtonWrap>
        <S.ButtonBox>
          <div className="small">
            <Button
              type="button"
              size="full"
              color="transparent"
              label="취소"
              onClick={onBackHanlder}
            />
          </div>
          <Button type="submit" size="full" color="primary" label="저장" />
        </S.ButtonBox>
      </S.ButtonWrap>
    </S.UserInfoEditContentLayout>
  );
};

export default UserInfoEditPageContent;
